<section class="container">
	<div class="divider">
		<h2 class="secondary-header !mb-0">Entry Requirements</h2>
		<div
			class="min-w-full mt-8 overflow-hidden font-medium text-gray-900 border border-gray-200 divide-y divide-gray-200 rounded-lg"
		>
			@for (entry of entryRequirements(); track $index) {
				<div class="px-4 py-6 select-none">
					<div
						ucToggleFaq
						class="flex justify-between cursor-pointer"
						data-cy="entry-requirement-faq-toggle"
					>
						<h3>
							{{ entry.type }}
						</h3>
						<div>
							<uc-arrow-down-svg customStyles="!w-6 !h-6 ml-1" />
							<uc-arrow-up-svg customStyles="hidden" />
						</div>
					</div>
					<div
						class="mt-3 text-gray-500 sr-only"
						data-cy="entry-requirement-faq-content"
					>
						@if (entry.min_entry) {
							<p class="pt-2">
								{{ entry.min_entry }}
							</p>
						}
						@if (entry.max_entry) {
							<p class="pt-2">
								{{ entry.max_entry }}
							</p>
						}
						@if (entry.information) {
							<p class="pt-2">
								{{ entry.information }}
							</p>
						}
						@if (isFeatured() && externalUrl() && visitWebsiteBtnRef) {
							<div class="mt-6">
								<ng-container
									[ngTemplateOutlet]="visitWebsiteBtnRef"
									[ngTemplateOutletContext]="{
										$implicit: { entry },
									}"
								>
								</ng-container>
							</div>
						}
					</div>
				</div>
			}
		</div>
	</div>
</section>
